import moment from "moment";
export function priceFormatter(originalPrice) {
	let price = originalPrice;
	if (!price) {
		return null;
	}
	if (typeof price === "number") {
		price = price.toString();
	}
	let [intPart, floatPart] = price.split(".");
	let floatPartLen = floatPart ? floatPart.length : 0;
	while (floatPartLen > 0 && floatPart.endsWith("0")) {
		floatPart = floatPart.substring(0, --floatPartLen);
	}
	if (floatPartLen > 0) return intPart + "." + floatPart;
	return intPart;
}

/** 结束时间倒计时 mixins */
const EndTimeCountDownMixins = {
	data() {
		return {
			remainingDate: "",
			remainingTime: "",
			timer: null,
			countDownTargetTime: null,
		};
	},
	beforeDestroy() {
		this.clearTimer();
	},
	methods: {
		clearTimer() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		startCountDown() {
			this.clearTimer();
			if (!this.countDownTargetTime) return;
			const target = moment(this.countDownTargetTime);
			if (!target.isValid()) return;
			const remainingTimeHandler = () => {
				const now = moment();
				const duration = target.diff(now);
				// console.log(duration, 'duration');
				// 倒计时到点
				if (duration <= 0) {
					this.$emit("countDownFinish");
					this.clearTimer();
					return;
				}
				const durationMoment = moment.duration(duration);
				const handlerDateQueue = [
					["years", "年"],
					["months", "月"],
					["days", "天"],
				];
				this.remainingDate = handlerDateQueue.reduce(
					(str, [method, suffix]) => {
						const value = durationMoment[method]();
						if (value || str) {
							str += value + suffix;
						}
						return str;
					},
					""
				);
				const handlerTimeQueue = ["hours", "minutes", "seconds"];
				this.remainingTime = handlerTimeQueue
					.map((key) => {
						const value = durationMoment[key]();
						return value < 10 ? "0" + value : value;
					})
					.join(":");
			};
			remainingTimeHandler();
			this.timer = setInterval(() => {
				remainingTimeHandler();
			}, 1000);
		},
	},
};

export { EndTimeCountDownMixins };
